import {TranslateLoader} from "@ngx-translate/core";
import {HttpClient} from "@angular/common/http";
import {Inject, makeStateKey, PLATFORM_ID, TransferState} from "@angular/core";
import {Observable, of} from "rxjs";
import {tap} from "rxjs/operators";

export class CustomTranslateLoader implements TranslateLoader {

    constructor(
        private http: HttpClient,
        private state: TransferState,
        @Inject(PLATFORM_ID) private platformId: any
    ) {

    }

    getTranslation(lang: string): Observable<any> {
        const translation = this.getTranslationFromState(lang);

        if (!translation) {
            let url: string;
            const defaultLanguage = 'en';
            if (lang === defaultLanguage) {
                url = `/assets/locales/${defaultLanguage}.json?t=${Date.now()}`;
            } else {
                url = `/assets/locales/${lang}.json?t=${Date.now()}`;
            }

            return this.http.get(url).pipe(
                tap(_translation => this.setTranslationToState(lang, _translation))
            );
        }

        return of(translation);
    }

    private getTranslationFromState(lang: string): Observable<string> {
        const stateKey = makeStateKey<string>(lang);
        return this.state.get<any>(stateKey, undefined);
    }

    private setTranslationToState(lang: string, translation: any): void {
        const stateKey = makeStateKey<any>(lang);

        this.state.set(stateKey, translation);
    }
}

export function HttpLoaderFactory(http: HttpClient, state: TransferState, platformId: any) {
    return new CustomTranslateLoader(http, state, platformId);
}
